// Parallaxe légère et effet fenêtre (maquette « 30 sept ») :
// - `[data-anima-parallax="f"]` glisse à l'intérieur de son cadre de (centre du cadre − milieu
//   de l'écran) × −f px (`data-parallax`) ;
// - `[data-anima-fixe]` reste immobile par rapport à l'écran pendant que son cadre défile
//   (`data-pxfix`, cartes acheteur et producteur) : translation de −(haut du cadre).
// Doctrine docs/06 : défilement natif, `transform` seul, écoute du défilement seulement quand le
// cadre du visuel est à l'écran, ≥ lg et hors réduction des animations. On observe le cadre et non
// le visuel : déplacé par le script, le visuel pouvait sortir de son cadre au dernier calcul, ne
// plus jamais y être visible et rester coincé dehors (cartes acheteur et producteur vides, 03/10).

const QUERY = '(min-width: 992px) and (prefers-reduced-motion: no-preference)'
const HALF = 2

const init = () => {
  const items = [...document.querySelectorAll('[data-anima-parallax], [data-anima-fixe]')]
  if (!items.length || !window.matchMedia(QUERY).matches || !('IntersectionObserver' in window)) {
    return
  }
  const visible = new Set()
  let frame = 0

  const render = () => {
    frame = 0
    const mid = window.innerHeight / HALF
    visible.forEach((el) => {
      const box = el.parentElement.getBoundingClientRect()
      const shift = 'animaFixe' in el.dataset
        ? -box.top
        : (box.top + box.height / HALF - mid) * -parseFloat(el.dataset.animaParallax)
      el.style.transform = `translate3d(0, ${shift.toFixed(1)}px, 0)`
    })
  }
  const onScroll = () => {
    if (!frame) {
      frame = requestAnimationFrame(render)
    }
  }

  const visuels = new Map(items.map((el) => [el.parentElement, el]))
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = visuels.get(entry.target)
      if (entry.isIntersecting) {
        visible.add(el)
        el.style.willChange = 'transform'
      } else {
        visible.delete(el)
        el.style.willChange = ''
      }
    })
    if (visible.size) {
      window.addEventListener('scroll', onScroll, {
        passive: true
      })
      onScroll()
    } else {
      window.removeEventListener('scroll', onScroll)
    }
  })
  visuels.forEach((el, cadre) => io.observe(cadre))
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
